.errorNotify {
  visibility: hidden;
  width: 100%;
  padding: 16px;
  background-color: var(--vkui--color_background_negative);
  color: var(--vkui--color_link_contrast);
  position: absolute;
  display: flex;
  justify-content: space-between;

  --top: 0px;

  top: var(--top);
  z-index: 999;
  box-sizing: border-box;
  opacity: 0;
  min-height: 48px;
  transition:
    top 0.4s cubic-bezier(0.22, 0.61, 0.36, 1),
    opacity 0.3s ease-out,
    visibility 0.4s linear;

  &.visible {
    visibility: visible;
    opacity: 1;

    --top: 48px;

    top: var(--top);
    transition:
      top 0.4s cubic-bezier(0.22, 0.61, 0.36, 1),
      opacity 0.2s ease-out 0.1s,
      visibility 0s linear;
  }
}

.errorNotify:not(.visible) {
  --top: 0px;

  top: var(--top);
  transition:
    top 0.3s cubic-bezier(0.55, 0.06, 0.68, 0.19),
    opacity 0.25s ease-out,
    visibility 0.3s linear 0.25s;
}

.closeButton {
  cursor: pointer;
  flex-shrink: 0;
}
